import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import LiteTradeNotification from "./LiteTradeNotification";
import { ORDER_TYPES } from "../../../../components/OrderTypeSelector/orderTypeSelectorConstants";

function LiteTradeNotificationProtectionOrderInfo(props) {
    const {
        accountType,
        assetInstance,
        description,
        order,
        price,
        status,
        symbol,
        type,
        withCloseButton,
    } = props;
    const {getLangPath} = useLangContext();
    const notificationOrderType = getLangPath(order.type === ORDER_TYPES.STOP
        ? 'lite_version.order.stop_loss'
        : 'lite_version.order.take_profit'
    );
    return <LiteTradeNotification
        accountType={accountType}
        description={description}
        status={status}
        symbol={symbol}
        type={type}
        withCloseButton={withCloseButton}
    >
        <div className="f14 mt-2" dangerouslySetInnerHTML={{
            __html: getLangPath('lite_version.notifications.protection_order_info', {
                order_type: notificationOrderType,
                price: assetInstance.roundAmount(price || 0),
            })
        }}/>
    </LiteTradeNotification>
}

export default LiteTradeNotificationProtectionOrderInfo;
